import React from 'react';
import HiddenLoader from '@fuww/library/src/HiddenLoader';

const HiddenLoading = () => <HiddenLoader />;

export default HiddenLoading;
